/**
 * kaynak-referans expressions/utils/EmojiUtils paritesi (adapte port).
 *
 * kaynak-referans sürümü URL'leri RuntimeConfig.staticCdnEndpoint üzerinden kurar;
 * TEBHOS'ta kendi statik CDN'imiz yok — Twemoji.tsx'in kullandığı jsDelivr
 * Twemoji CDN'ine (jdecked/twemoji fork) bağlanıyoruz. Codepoint dönüşümü
 * kaynak-referans EmojiCodepointUtils'in birebiri (ZWJ varsa FE0F korunur).
 */

import { convertToCodePoints } from "@app/features/expressions/utils/EmojiCodepointUtils";

const TWEMOJI_BASE = "https://cdn.jsdelivr.net/gh/jdecked/twemoji@17.0.2/assets/svg";
const TWEMOJI_URL_CACHE_LIMIT = 2048;

const TWEMOJI_URL_CACHE = new Map<string, string | null>();

/** Hex codepoint string'ini ("1f600") gerçek karaktere çevirir. */
export function fromHexCodePoint(hex: string): string {
  return String.fromCodePoint(Number.parseInt(hex, 16));
}

/** Codepoint dizisi ("1f44b-1f3fd") → Twemoji SVG URL'i (LRU-vari cache'li). */
export function getTwemojiURL(codePoints: string): string | null {
  if (!codePoints) {
    return null;
  }
  const cached = TWEMOJI_URL_CACHE.get(codePoints);
  if (cached !== undefined) {
    return cached;
  }
  const url = `${TWEMOJI_BASE}/${codePoints}.svg`;
  if (TWEMOJI_URL_CACHE.size >= TWEMOJI_URL_CACHE_LIMIT) {
    TWEMOJI_URL_CACHE.clear();
  }
  TWEMOJI_URL_CACHE.set(codePoints, url);
  return url;
}

/** Unicode emoji karakteri → Twemoji SVG URL'i. */
export function getEmojiURL(unicode: string): string | null {
  return getTwemojiURL(convertToCodePoints(unicode));
}
